import {
    BorrowerPortalApiFactory,
    BPMSResourcesManagementApiFactory,
    Configuration,
    ProcessDefinitionManagerApiFactory,
    TaskManagerApiFactory,
    UISettingsApiFactory,
} from 'src/generated-api-client';

const apiConfig: Configuration | undefined = undefined;
const basePath = '';

const filesApiPath = '/api/file?';
export const getFileUrl = (filename: string) => {
    const searchParams = new URLSearchParams();
    searchParams.append('form', filename);

    return `${filesApiPath}${searchParams.toString()}`;
};

export const processApi = ProcessDefinitionManagerApiFactory(
    apiConfig,
    basePath,
);

export const taskApi = TaskManagerApiFactory(apiConfig, basePath);

export const uiSettingsApi = UISettingsApiFactory(apiConfig, basePath);

export const bpmsResourcesManagerApi = BPMSResourcesManagementApiFactory(
    apiConfig,
    basePath,
);

export const borrowerApi = BorrowerPortalApiFactory(apiConfig, basePath);

export const requestsApi = BorrowerPortalApiFactory(apiConfig, basePath);
